import { ApolloError } from '@apollo/client/errors';
import { Component, type PropsWithChildren } from 'react';

import QueryErrors from '~/shared/components/QueryErrors';

class QueryErrorBoundary extends Component<PropsWithChildren<{}>, { error: ApolloError | null }> {
  state = { error: null };

  static getDerivedStateFromError(error: Error) {
    if (error instanceof ApolloError) {
      return { error };
    }
    return { error: null };
  }

  render() {
    if (this.state.error) {
      return <QueryErrors error={this.state.error} />;
    }

    const { children } = this.props;

    return children;
  }
}

export default QueryErrorBoundary;
